import MosaicTemplate from '@components/templates/mosaic/ui/mosaic';
import useSettings from './lib/useSettings';

export default function SettingsPage() {
  const settings = useSettings();
  return (
    <MosaicTemplate
      data={settings}
      flags={{
        complete: true,
        hasDescription: false,
        hasFloatingMenu: false,
        hasSettings: true,
      }}
    />
  );
}
